import { useQuery } from "@apollo/client";
import Errors from "components/Errors";
import Page from "components/Page";
import SearchBar from "components/SearchBar";
import { Select } from "components/Select";
import Spinner from "components/Spinner";
import { useSearchParams } from "react-router-dom";
import { useDebouncedCallback } from "use-debounce";
import { FETCH_POS } from "./graphql";
import PurchaseOrderTableView from "./PurchaseOrderTableView";

export const PAGE_SIZE = 50;

function getReceiptStatusValues(filter) {
  if (filter === "NOT_COMPLETED") return ["pending", "partial"];
  if (filter === "FULL") return ["full"];
  return undefined;
}

const PurchaseOrdersPage = () => {
  const [searchParams, setSearchParams] = useSearchParams({
    offset: 0,
    q: "",
    receiptStatus: "NOT_COMPLETED",
  });
  const q = searchParams.get("q");
  const receiptStatusFilter =
    searchParams.get("receiptStatus") || "NOT_COMPLETED";
  const offset = parseInt(searchParams.get("offset"), 10) || 0;
  const { loading, error, data } = useQuery(FETCH_POS, {
    variables: {
      offset,
      limit: PAGE_SIZE,
      q: q?.trim() ? q.trim() : undefined,
      receiptStatus: getReceiptStatusValues(receiptStatusFilter),
    },
    fetchPolicy: "network-only",
  });
  const debouncedSetQuery = useDebouncedCallback((text) => {
    setSearchParams((prev) => {
      const p = new URLSearchParams(prev);
      p.set("offset", "0");
      if (text.trim() === "") {
        p.delete("q");
      } else {
        p.set("q", text);
      }
      return p;
    });
  }, 1000);

  return (
    <Page title="Orders 订单">
      <div className="m-8 mb-0 flex items-center space-x-6">
        <Select
          value={receiptStatusFilter}
          onChange={(e) => {
            setSearchParams((prev) => {
              const p = new URLSearchParams(prev);
              p.set("offset", "0");
              p.set("receiptStatus", e.target.value);
              return p;
            });
          }}
        >
          <option value="NOT_COMPLETED">未交付、部分交付</option>
          <option value="FULL">已交付</option>
          <option value="ALL">所有订单</option>
        </Select>
        <div className="flex-1">
          <SearchBar
            placeholder="Search by order number or product name 根据订单号、产品编码或产品名称搜索"
            initialQuery={q || ""}
            onChange={debouncedSetQuery}
          />
        </div>
      </div>

      <div className="card m-8 mt-4 flex-1 flex flex-col overflow-auto p-0 rounded-xl">
        {loading ? (
          <Spinner />
        ) : error ? (
          <Errors error={error} />
        ) : (
          <PurchaseOrderTableView
            data={data}
            q={q}
            receiptStatusFilter={receiptStatusFilter}
            setSearchParams={setSearchParams}
            offset={offset}
          />
        )}
      </div>
    </Page>
  );
};

export default PurchaseOrdersPage;
